import { ICellRendererParams } from 'ag-grid-community'
import { EAccessCodeOwnership, EAccessCodeOwnershipLabels } from 'types'

/**
 * Every code that exists today is organizational — the backend classifies them that way and only
 * generates `individual` codes for Individual Trainee subscriptions. So a missing value is shown
 * as Organizational rather than as a placeholder.
 */
export const AccessManagementColumnOwnership = (
  props: ICellRendererParams<{ ownership?: EAccessCodeOwnership }>,
) => {
  const ownership = props?.data?.ownership ?? EAccessCodeOwnership.organizational

  return EAccessCodeOwnershipLabels[ownership] ?? ownership
}
